/* Volteura 2026-04-18 — site-wide subtle motion */
(function () {
  'use strict';

  /* ---------- 1. Scroll-triggered fade-up on main sections ---------- */
  var selector = [
    '.v2-hero', '.v2-pain', '.v2-steps', '.v2-flows',
    '.v2-edge', '.v2-proof', '.v2-pricing', '.v2-faq',
    '.v2-final', '.v2-footer',
    '.v-dash-header', '.v-stats-grid', '.v-section-title', '.v-workflow-grid',
    '.v-auth-card'
  ].join(',');

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function armReveals() {
    var targets = document.querySelectorAll(selector);
    targets.forEach(function (t) { t.classList.add('v2-reveal'); });
    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (t) { io.observe(t); });
    // Hero — already above fold — reveal on next frame so transition still plays
    var hero = document.querySelector('.v2-hero');
    if (hero) requestAnimationFrame(function () { hero.classList.add('is-in'); });
    var dash = document.querySelector('.v-dash-header');
    if (dash) requestAnimationFrame(function () { dash.classList.add('is-in'); });
  }

  /* ---------- 2. Count-up for dashboard stat values ---------- */
  function countUp(el, target, duration) {
    duration = duration || 1400;
    var str = String(target);
    var numMatch = str.match(/-?[\d,.]+/);
    if (!numMatch) return;
    var numTarget = parseFloat(numMatch[0].replace(/,/g, ''));
    if (isNaN(numTarget)) return;
    var hasPercent = /%$/.test(str);
    var suffix = hasPercent ? '%' : '';
    var isInt = numTarget === Math.floor(numTarget);
    var start = performance.now();
    function step(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var v = numTarget * eased;
      el.textContent = (isInt ? Math.round(v) : v.toFixed(1)) + suffix;
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = str; // ensure exact final match
    }
    requestAnimationFrame(step);
  }

  function armCounters() {
    if (prefersReduced) return;
    var stats = document.querySelectorAll('.v-stat-value');
    if (!stats.length) return;
    stats.forEach(function (el) {
      var obs = new MutationObserver(function () {
        var current = el.textContent.trim();
        if (current && current !== '\u2014' && !el.dataset.counted) {
          el.dataset.counted = '1';
          obs.disconnect();
          // Intersection-gate so counter runs when user sees it
          if ('IntersectionObserver' in window) {
            var io2 = new IntersectionObserver(function (entries, self) {
              entries.forEach(function (e) {
                if (e.isIntersecting) {
                  countUp(el, current);
                  self.unobserve(el);
                }
              });
            }, { threshold: 0.5 });
            io2.observe(el);
          } else {
            countUp(el, current);
          }
        }
      });
      obs.observe(el, { childList: true, characterData: true, subtree: true });
      // if value was already present before we attached observer
      if (el.textContent.trim() && el.textContent.trim() !== '\u2014' && !el.dataset.counted) {
        el.dataset.counted = '1';
        obs.disconnect();
        countUp(el, el.textContent.trim());
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { armReveals(); armCounters(); });
  } else {
    armReveals();
    armCounters();
  }
})();
